import { FC, PropsWithChildren, useState } from 'react'

import { NotificationSortContext } from './useNotificationSortContext'
import { NotificationSortOrder } from '../api/notifications.service'

export type SortOption = 'newestFirst' | 'byPriority'

export type SelectedSort = {
  field: NotificationSortOrder
  direction: 'asc' | 'desc'
  key: SortOption
}

export const NotificationSortContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [sort, setSort] = useState<SelectedSort>({ field: 'createdAt', direction: 'desc', key: 'newestFirst' })

  return (
    <NotificationSortContext.Provider
      value={{
        sort,
        setSort,
      }}
    >
      {children}
    </NotificationSortContext.Provider>
  )
}
